import React from 'react'
import CarouselHome from './carouselHome/Carousel-Home'

const Home = () => {
    return (
        <CarouselHome />
    )
}

export default Home